import React from 'react'
import PropTypes from 'prop-types'

const Processing = (props) => {
  return (
    <div className="processing-container">
      <h1>The content is currently being processed...</h1>
      <h1>Loading...</h1>
    </div>
  )
}

export default Processing